var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 18c0-1.333 0-2.667 0-4-1.48-0.234-2.967-0.411-4.456-0.558-0.117-0.346-0.253-0.678-0.414-1.001 0.945-1.153 1.892-2.305 2.769-3.513-0.943-0.943-1.886-1.886-2.828-2.828-1.208 0.878-2.36 1.824-3.513 2.769-0.323-0.162-0.655-0.297-1.001-0.414-0.147-1.489-0.323-2.976-0.558-4.456h-4c-0.234 1.48-0.411 2.967-0.558 4.456-0.346 0.117-0.678 0.253-1.001 0.414-1.153-0.945-2.305-1.892-3.513-2.77-0.943 0.943-1.886 1.886-2.829 2.829 0.878 1.208 1.824 2.36 2.769 3.513-0.161 0.323-0.297 0.655-0.414 1.001-1.489 0.147-2.976 0.323-4.456 0.558 0 1.333 0 2.667 0 4 1.48 0.234 2.967 0.411 4.456 0.558 0.117 0.346 0.253 0.678 0.414 1.001-0.945 1.153-1.892 2.305-2.769 3.513 0.943 0.943 1.886 1.886 2.828 2.828 1.208-0.878 2.36-1.824 3.513-2.769 0.323 0.161 0.655 0.297 1.001 0.414 0.147 1.489 0.323 2.976 0.558 4.456h4c0.234-1.48 0.411-2.967 0.558-4.456 0.346-0.117 0.678-0.253 1.001-0.414 1.153 0.945 2.305 1.892 3.513 2.769 0.943-0.943 1.886-1.886 2.828-2.828-0.878-1.208-1.824-2.36-2.769-3.513 0.161-0.323 0.297-0.655 0.414-1.001 1.489-0.147 2.976-0.323 4.456-0.558zM16 19c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityGear);
export default __webpack_public_path__ + "static/media/unity_gear.04bfbf8669bd882655c75fbd72f3282a.svg";
export { ForwardRef as ReactComponent };